import { render } from "./membership-card.vue?vue&type=template&id=6456b588&lang=pug"
import script from "./membership-card.vue?vue&type=script&setup=true&lang=js"
export * from "./membership-card.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__